import Vue from 'vue'

require('./assets/stylesheets/app.scss')

var $ = require('jquery')

if (!window.navigator.oscpu) window.navigator.oscpu = window.navigator.platform

$('body').addClass(window.navigator.oscpu.toLowerCase().indexOf("win") !== -1 ? "os-windows" : "os-notwindows")

// Prevent swipe navigation
$(document).on("mousewheel",function(event,delta){ 
  if (event.originalEvent.wheelDeltaX !== 0) {
    event.preventDefault();
  } 
});
$(document).on("contextmenu",function(e){
  return false;
});


// Copy

var copy = {"attract__title":"Migration",
            "attract__subtitle":"Settlers in Britain since 1841",
            "attract__button":"Explore the timeline",
            "attract__intro":"World events and changing conditions affect patterns of migration to Britain. This interactive timeline illustrates migration trends since 1841 using information from the Office for National Statistics and the ten-yearly Census.",
            "masthead__title":"Migration to Britain since 1841",
            "content__primary__title":"Britain's residents born overseas",
            "content__primary__firstcontent":"Top countries of birth, by rise in numbers over previous 10 years",
            "content__secondary__percentage":"Percentage of Britain's residents born overseas",
            "buttons__fulldata":"View full data",
            "buttons__netmigration":"View net migration",
            "fulldata__title":"",
            "fulldata__xtitle":"Number of residents in Britain",
            "fulldata__ytitle":"Country of birth",
            "netmigration__title": "UK Migration 1964-2016",
            "netmigration__immigration": "People moving into UK",
            "netmigration__emigration": "People moving out of UK",
            "help__title":"Migration to Britain since 1841",
            "help__slider":"Use the timeline slider at the bottom of the screen to explore key data and world events related to migration to Britain.",
            "help__census1":"The ten-yearly UK Census counts the numbers of people resident in Britain but born overseas. The ‘BRITAIN’S RESIDENTS BORN OVERSEAS – TOP COUNTRIES’ list, and the markers on the globe, show the largest rises in Britain’s overseas-born residents, by country of birth, compared to the previous Census.",
            "help__census2":"The total number of people from each country living in Britain at each Census is shown on the ‘VIEW FULL DATA’ screen. Tap on the graph to see country figures.",
            "help__netmigration":"‘View Net Migration’ shows patterns of migration into and out of the UK between 1964 and 2016.",
            "help__smalltext":"Contains public sector information licensed under the Open Government Licence v3.0"}

// Globe
var globe = require('./assets/scripts/globe.js');

// App data

import * as VueChartJs from 'vue-chartjs';

Vue.component('fulldatachart', {
  extends: VueChartJs.Bar,
  mixins: [VueChartJs.mixins.reactiveProp],
  props: ['chartData'],
  mounted: function () {
    this.renderChart(this.chartData,
                     {responsive: true,
                      maintainAspectRatio: true,
                      legend: {
                          display: false
                      },
                      scales: {
                          xAxes: [{
                              id: 'line-axis',
                              type: 'category',
                              offset: true,
                              barPercentage: 1.0,
                              categoryPercentage: 0.5,
                              gridLines: {
                                color: 'rgba(255,255,255,1)',
                                display: false,
                                drawTicks: true,
                                drawBorder: false
                              },
                              scaleLabel: {
                                labelString: "COUNTRY OF BIRTH",
                                display: true,
                                fontColor: '#fff'
                              },
                              ticks: {
                                display: true,
                                minRotation: 90,
                                fontColor: "white",
                                fontFamily: "'HelveticaNeueLight','Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                fontSize: 12
                              }}],
                          yAxes: [{
                              gridLines: {
                                  display: true,
                                  color: 'rgba(255,255,255,0.1)',
                                  lineWidth: 2,
                                  zeroLineColor: 'rgba(255,255,255,1)',
                                  zeroLineWidth: 2,
                                  drawTicks: false,
                                  drawBorder: false
                              },
                              scaleLabel: {
                                labelString: "NUMBER OF RESIDENTS IN BRITAIN",
                                display: true,
                                fontColor: '#fff',
                                padding: 10
                              },
                              ticks: {
                                  display: true,
                                  fontColor: "white",
                                  fontFamily: "'HelveticaNeueLight','Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                                  fontSize: 20,
                                  padding: 20,
                                  callback: function(value, index, values) {
                                    return value > 0 ? decimalMark(value) : '';
                                  }
                              },
                          }]
                      },
                      tooltips: {
                        titleFontSize: 20,
                        bodyFontSize: 18,
                        // intersect: false,
                        // mode: 'x',
                        // position: 'nearest',
                        callbacks: {
                          label:function(tooltipItem, chart){
                            return decimalMark(tooltipItem.yLabel.toString())
                          }
                        }
                      }
                    }
                  );
  },
  methods: {
    update() {
      this.$data._chart.update();
    }
  }
})

var netMigrationData = [[1964,-60,211,271],[1965,-78,206,284],[1966,-82,219,302],[1967,-84,225,309],[1968,-56,222,278],[1969,-87,206,293],[1970,-65,226,291],[1971,-40,200,240],[1972,-11,222,233],[1973,-50,196,246],[1974,-85,184,269],[1975,-41,197,238],[1976,-19,191,210],[1977,-46,162,208],[1978,-5,187,192],[1979,6,195,189],[1980,-55,173,228],[1981,-79,153,232],[1982,-56,201,257],[1983,17,202,184],[1984,37,201,164],[1985,58,232,174],[1986,37,250,213],[1987,2,211,209],[1988,-21,216,237],[1989,44,250,205],[1990,36,267,231],[1991,44,329,285],[1992,-13,268,281],[1993,-1,266,266],[1994,77,315,238],[1995,76,312,236],[1996,55,318,264],[1997,48,327,279],[1998,140,391,251],[1999,163,454,291],[2000,158,479,321],[2001,179,481,309],[2002,172,516,363],[2003,185,511,363],[2004,268,589,344],[2005,267,567,361],[2006,265,596,398],[2007,273,574,341],[2008,229,590,427],[2009,229,567,368],[2010,256,591,339],[2011,205,566,351],[2012,177,498,321],[2013,209,526,317],[2014,313,632,319],[2015,333,630,297],[2016,230,572,342]]
Vue.component('netmigrationchart', {
    extends: VueChartJs.Bar,
    mounted: function() {
        this.renderChart(
        {
            labels: netMigrationData.map(d => d[0]),
            datasets: [{
                id: "year",
                xAxisID: "line-axis",
                type: 'bar',
                data: netMigrationData.map(d => d[1]),
                backgroundColor: "#f7db00"
            }, {
                type: 'line',
                xAxisID: "line-axis",
                data: netMigrationData.map(d => d[2]),
                lineTension: 0,
                fill: false,
                pointRadius: 0,
                borderColor: "#00b4e8",
                borderWidth: 2
            }, {
                type: 'line',
                xAxisID: "line-axis",
                data: netMigrationData.map(d => d[3]),
                lineTension: 0,
                fill: false,
                pointRadius: 0,
                borderColor: "#db7b3f",
                borderWidth: 2
            }]
        },
        {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            tooltips: {
              titleFontSize: 20,
              bodyFontSize: 18,
              intersect: false,
              mode: 'x',
              position: 'nearest',
              callbacks: {
                label:function(tooltipItem, chart){
                  return tooltipItem.yLabel.toString() + ',000'
                }
              }
            },
            scales: {
                xAxes: [{
                    id: 'line-axis',
                    type: 'category',
                    offset: true,
                    barPercentage: 1.0,
                    categoryPercentage: 0.5,
                    gridLines: {
                      color: 'rgba(255,255,255,1)',
                      display: false,
                      drawTicks: true,
                      drawBorder: false
                    },
                    ticks: {
                      display: true,
                      maxRotation: 0,
                      fontColor: "white",
                      fontFamily: "'HelveticaNeueLight','Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                      fontSize: 14,
                      padding: 60,
                    }}],
                yAxes: [{
                    gridLines: {
                        display: true,
                        color: 'rgba(255,255,255,0.1)',
                        lineWidth: 2,
                        zeroLineColor: 'rgba(255,255,255,1)',
                        zeroLineWidth: 2,
                        drawTicks: false,
                        drawBorder: false
                    },
                    ticks: {
                        display: true,
                        fontColor: "white",
                        fontFamily: "'HelveticaNeueLight','Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                        fontSize: 20,
                        padding: 20,
                        callback: function(value, index, values) {
                          return value != 0 ? decimalMark(value * 1000) : '';
                        }
                    },
                }]
            }
        })
    }
})

// Countrywise migration data

var migrationData = [
  {
    "year": "1841",
    "type": "data",
    "percentage": "2.9",
    "populations": {
      "All people": "18526925",
      "England & Wales": "15400467",
      "Scotland": "2542507",
      "England": "",
      "Wales": "",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 0
      },
      {
        "name": "Republic of Ireland",
        "value": 415725
      },
      {
        "name": "Northern Ireland",
        "value": 0
      },
      {
        "name": "British Empire",
        "value": 1360
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 0
      },
      {
        "name": "Canada",
        "value": 0
      },
      {
        "name": "Australia",
        "value": 0
      },
      {
        "name": "New Zealand",
        "value": 0
      },
      {
        "name": "Other Oceania",
        "value": 0
      },
      {
        "name": "Caribbean",
        "value": 0
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 0
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 0
      },
      {
        "name": "Other Africa",
        "value": 0
      },
      {
        "name": "Hungary",
        "value": 0
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 0
      },
      {
        "name": "France",
        "value": 0
      },
      {
        "name": "Germany",
        "value": 0
      },
      {
        "name": "Greece",
        "value": 0
      },
      {
        "name": "Italy",
        "value": 0
      },
      {
        "name": "Netherlands",
        "value": 0
      },
      {
        "name": "Portugal",
        "value": 0
      },
      {
        "name": "Spain",
        "value": 0
      },
      {
        "name": "Sweden",
        "value": 0
      },
      {
        "name": "Malta & Gozo",
        "value": 0
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 0
      },
      {
        "name": "Czech Republic",
        "value": 0
      },
      {
        "name": "Poland",
        "value": 0
      },
      {
        "name": "Romania",
        "value": 0
      },
      {
        "name": "Turkey",
        "value": 0
      },
      {
        "name": "Other Europe",
        "value": 0
      },
      {
        "name": "Cyprus",
        "value": 0
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 0
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 0
      },
      {
        "name": "Malaysia",
        "value": 0
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 0
      },
      {
        "name": "United States of America",
        "value": 0
      },
      {
        "name": "South America",
        "value": 0
      },
      {
        "name": "Other America",
        "value": 0
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 124846
      }
    ]
  },
  {
    "year": "1851",
    "type": "data",
    "percentage": "3.8",
    "populations": {
      "All people": "20816351",
      "England & Wales": "17212447",
      "Scotland": "2752807",
      "England": "16164101",
      "Wales": "1048346",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 14411
      },
      {
        "name": "Republic of Ireland",
        "value": 727326
      },
      {
        "name": "Northern Ireland",
        "value": 0
      },
      {
        "name": "British Empire",
        "value": 40231
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 0
      },
      {
        "name": "Canada",
        "value": 0
      },
      {
        "name": "Australia",
        "value": 0
      },
      {
        "name": "New Zealand",
        "value": 0
      },
      {
        "name": "Other Oceania",
        "value": 0
      },
      {
        "name": "Caribbean",
        "value": 0
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 0
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 0
      },
      {
        "name": "Other Africa",
        "value": 0
      },
      {
        "name": "Hungary",
        "value": 0
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 0
      },
      {
        "name": "France",
        "value": 0
      },
      {
        "name": "Germany",
        "value": 0
      },
      {
        "name": "Greece",
        "value": 0
      },
      {
        "name": "Italy",
        "value": 0
      },
      {
        "name": "Netherlands",
        "value": 0
      },
      {
        "name": "Portugal",
        "value": 0
      },
      {
        "name": "Spain",
        "value": 0
      },
      {
        "name": "Sweden",
        "value": 0
      },
      {
        "name": "Malta & Gozo",
        "value": 0
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 0
      },
      {
        "name": "Czech Republic",
        "value": 0
      },
      {
        "name": "Poland",
        "value": 0
      },
      {
        "name": "Romania",
        "value": 0
      },
      {
        "name": "Turkey",
        "value": 0
      },
      {
        "name": "Other Europe",
        "value": 0
      },
      {
        "name": "Cyprus",
        "value": 0
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 0
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 0
      },
      {
        "name": "Malaysia",
        "value": 0
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 0
      },
      {
        "name": "United States of America",
        "value": 0
      },
      {
        "name": "South America",
        "value": 0
      },
      {
        "name": "Other America",
        "value": 0
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 3149
      }
    ]
  },
  {
    "year": "1861",
    "type": "data",
    "percentage": "4.3",
    "populations": {
      "All people": "23128518",
      "England & Wales": "19176084",
      "Scotland": "2955006",
      "England": "18040537",
      "Wales": "1135547",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 19051
      },
      {
        "name": "Republic of Ireland",
        "value": 805717
      },
      {
        "name": "Northern Ireland",
        "value": 0
      },
      {
        "name": "British Empire",
        "value": 59131
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 0
      },
      {
        "name": "Canada",
        "value": 0
      },
      {
        "name": "Australia",
        "value": 0
      },
      {
        "name": "New Zealand",
        "value": 0
      },
      {
        "name": "Other Oceania",
        "value": 0
      },
      {
        "name": "Caribbean",
        "value": 0
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 0
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 153
      },
      {
        "name": "Other Africa",
        "value": 493
      },
      {
        "name": "Hungary",
        "value": 0
      },
      {
        "name": "Austria-Hungary",
        "value": 2383
      },
      {
        "name": "Belgium",
        "value": 2490
      },
      {
        "name": "France",
        "value": 16009
      },
      {
        "name": "Germany",
        "value": 36154
      },
      {
        "name": "Greece",
        "value": 700
      },
      {
        "name": "Italy",
        "value": 5583
      },
      {
        "name": "Netherlands",
        "value": 6888
      },
      {
        "name": "Portugal",
        "value": 659
      },
      {
        "name": "Spain",
        "value": 1824
      },
      {
        "name": "Sweden",
        "value": 2282
      },
      {
        "name": "Malta & Gozo",
        "value": 0
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 2051
      },
      {
        "name": "Czech Republic",
        "value": 0
      },
      {
        "name": "Poland",
        "value": 4461
      },
      {
        "name": "Romania",
        "value": 0
      },
      {
        "name": "Turkey",
        "value": 405
      },
      {
        "name": "Other Europe",
        "value": 10918
      },
      {
        "name": "Cyprus",
        "value": 0
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 173
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 0
      },
      {
        "name": "Malaysia",
        "value": 0
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 229
      },
      {
        "name": "United States of America",
        "value": 9561
      },
      {
        "name": "South America",
        "value": 591
      },
      {
        "name": "Other America",
        "value": 1849
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 3513
      }
    ]
  },
  {
    "year": "1871",
    "type": "data",
    "percentage": "3.8",
    "populations": {
      "All people": "26072284",
      "England & Wales": "21762647",
      "Scotland": "3274785",
      "England": "20342286",
      "Wales": "1420361",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 26384
      },
      {
        "name": "Republic of Ireland",
        "value": 774310
      },
      {
        "name": "Northern Ireland",
        "value": 0
      },
      {
        "name": "British Empire",
        "value": 80552
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 0
      },
      {
        "name": "Canada",
        "value": 0
      },
      {
        "name": "Australia",
        "value": 0
      },
      {
        "name": "New Zealand",
        "value": 0
      },
      {
        "name": "Other Oceania",
        "value": 0
      },
      {
        "name": "Caribbean",
        "value": 0
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 0
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 148
      },
      {
        "name": "Other Africa",
        "value": 257
      },
      {
        "name": "Hungary",
        "value": 0
      },
      {
        "name": "Austria-Hungary",
        "value": 1933
      },
      {
        "name": "Belgium",
        "value": 2599
      },
      {
        "name": "France",
        "value": 18402
      },
      {
        "name": "Germany",
        "value": 34354
      },
      {
        "name": "Greece",
        "value": 616
      },
      {
        "name": "Italy",
        "value": 5331
      },
      {
        "name": "Netherlands",
        "value": 6438
      },
      {
        "name": "Portugal",
        "value": 478
      },
      {
        "name": "Spain",
        "value": 1550
      },
      {
        "name": "Sweden",
        "value": 2167
      },
      {
        "name": "Malta & Gozo",
        "value": 0
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 2604
      },
      {
        "name": "Czech Republic",
        "value": 0
      },
      {
        "name": "Poland",
        "value": 7225
      },
      {
        "name": "Romania",
        "value": 0
      },
      {
        "name": "Turkey",
        "value": 535
      },
      {
        "name": "Other Europe",
        "value": 9719
      },
      {
        "name": "Cyprus",
        "value": 0
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 199
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 0
      },
      {
        "name": "Malaysia",
        "value": 0
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 169
      },
      {
        "name": "United States of America",
        "value": 8270
      },
      {
        "name": "South America",
        "value": 425
      },
      {
        "name": "Other America",
        "value": 1823
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 5106
      }
    ]
  },
  {
    "year": "1881",
    "type": "data",
    "percentage": "3.5",
    "populations": {
      "All people": "29710012",
      "England & Wales": "24947645",
      "Scotland": "3651287",
      "England": "23572070",
      "Wales": "1375575",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 30265
      },
      {
        "name": "Republic of Ireland",
        "value": 781119
      },
      {
        "name": "Northern Ireland",
        "value": 0
      },
      {
        "name": "British Empire",
        "value": 107273
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 0
      },
      {
        "name": "Canada",
        "value": 0
      },
      {
        "name": "Australia",
        "value": 0
      },
      {
        "name": "New Zealand",
        "value": 0
      },
      {
        "name": "Other Oceania",
        "value": 0
      },
      {
        "name": "Caribbean",
        "value": 0
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 0
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 84
      },
      {
        "name": "Other Africa",
        "value": 189
      },
      {
        "name": "Hungary",
        "value": 0
      },
      {
        "name": "Austria-Hungary",
        "value": 3036
      },
      {
        "name": "Belgium",
        "value": 2519
      },
      {
        "name": "France",
        "value": 15065
      },
      {
        "name": "Germany",
        "value": 39444
      },
      {
        "name": "Greece",
        "value": 748
      },
      {
        "name": "Italy",
        "value": 6832
      },
      {
        "name": "Netherlands",
        "value": 5553
      },
      {
        "name": "Portugal",
        "value": 312
      },
      {
        "name": "Spain",
        "value": 1490
      },
      {
        "name": "Sweden",
        "value": 3479
      },
      {
        "name": "Malta & Gozo",
        "value": 0
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 4014
      },
      {
        "name": "Czech Republic",
        "value": 0
      },
      {
        "name": "Poland",
        "value": 10990
      },
      {
        "name": "Romania",
        "value": 0
      },
      {
        "name": "Turkey",
        "value": 613
      },
      {
        "name": "Other Europe",
        "value": 10107
      },
      {
        "name": "Cyprus",
        "value": 0
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 212
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 0
      },
      {
        "name": "Malaysia",
        "value": 0
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 332
      },
      {
        "name": "United States of America",
        "value": 18306
      },
      {
        "name": "South America",
        "value": 197
      },
      {
        "name": "Other America",
        "value": 732
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 5327
      }
    ]
  },
  {
    "year": "1891",
    "type": "data",
    "percentage": "3.1",
    "populations": {
      "All people": "33028172",
      "England & Wales": "27993674",
      "Scotland": "3970971",
      "England": "26496910",
      "Wales": "1496764",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 31297
      },
      {
        "name": "Republic of Ireland",
        "value": 653122
      },
      {
        "name": "Northern Ireland",
        "value": 0
      },
      {
        "name": "British Empire",
        "value": 125234
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 0
      },
      {
        "name": "Canada",
        "value": 0
      },
      {
        "name": "Australia",
        "value": 0
      },
      {
        "name": "New Zealand",
        "value": 0
      },
      {
        "name": "Other Oceania",
        "value": 0
      },
      {
        "name": "Caribbean",
        "value": 0
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 0
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 382
      },
      {
        "name": "Other Africa",
        "value": 694
      },
      {
        "name": "Hungary",
        "value": 0
      },
      {
        "name": "Austria-Hungary",
        "value": 5866
      },
      {
        "name": "Belgium",
        "value": 3986
      },
      {
        "name": "France",
        "value": 21243
      },
      {
        "name": "Germany",
        "value": 52651
      },
      {
        "name": "Greece",
        "value": 1006
      },
      {
        "name": "Italy",
        "value": 10658
      },
      {
        "name": "Netherlands",
        "value": 6671
      },
      {
        "name": "Portugal",
        "value": 675
      },
      {
        "name": "Spain",
        "value": 2288
      },
      {
        "name": "Sweden",
        "value": 5093
      },
      {
        "name": "Malta & Gozo",
        "value": 0
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 24625
      },
      {
        "name": "Czech Republic",
        "value": 0
      },
      {
        "name": "Poland",
        "value": 21924
      },
      {
        "name": "Romania",
        "value": 0
      },
      {
        "name": "Turkey",
        "value": 1258
      },
      {
        "name": "Other Europe",
        "value": 18461
      },
      {
        "name": "Cyprus",
        "value": 0
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 796
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 0
      },
      {
        "name": "Malaysia",
        "value": 0
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 1100
      },
      {
        "name": "United States of America",
        "value": 20400
      },
      {
        "name": "South America",
        "value": 795
      },
      {
        "name": "Other America",
        "value": 5836
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 4992
      }
    ]
  },
  {
    "year": "1901",
    "type": "data",
    "percentage": "3.0",
    "populations": {
      "All people": "36999946",
      "England & Wales": "31403226",
      "Scotland": "4402593",
      "England": "",
      "Wales": "",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 36821
      },
      {
        "name": "Republic of Ireland",
        "value": 631629
      },
      {
        "name": "Northern Ireland",
        "value": 0
      },
      {
        "name": "British Empire",
        "value": 151999
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 0
      },
      {
        "name": "Canada",
        "value": 0
      },
      {
        "name": "Australia",
        "value": 0
      },
      {
        "name": "New Zealand",
        "value": 0
      },
      {
        "name": "Other Oceania",
        "value": 0
      },
      {
        "name": "Caribbean",
        "value": 0
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 0
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 211
      },
      {
        "name": "Other Africa",
        "value": 269
      },
      {
        "name": "Hungary",
        "value": 0
      },
      {
        "name": "Austria-Hungary",
        "value": 11198
      },
      {
        "name": "Belgium",
        "value": 4443
      },
      {
        "name": "France",
        "value": 21057
      },
      {
        "name": "Germany",
        "value": 52365
      },
      {
        "name": "Greece",
        "value": 1091
      },
      {
        "name": "Italy",
        "value": 24383
      },
      {
        "name": "Netherlands",
        "value": 7036
      },
      {
        "name": "Portugal",
        "value": 417
      },
      {
        "name": "Spain",
        "value": 2937
      },
      {
        "name": "Sweden",
        "value": 6195
      },
      {
        "name": "Malta & Gozo",
        "value": 0
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 68973
      },
      {
        "name": "Czech Republic",
        "value": 0
      },
      {
        "name": "Poland",
        "value": 24244
      },
      {
        "name": "Romania",
        "value": 0
      },
      {
        "name": "Turkey",
        "value": 1634
      },
      {
        "name": "Other Europe",
        "value": 23110
      },
      {
        "name": "Cyprus",
        "value": 0
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 425
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 453
      },
      {
        "name": "Malaysia",
        "value": 0
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 445
      },
      {
        "name": "United States of America",
        "value": 17358
      },
      {
        "name": "South America",
        "value": 1330
      },
      {
        "name": "Other America",
        "value": 372
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 4823
      }
    ]
  },
  {
    "year": "1911",
    "type": "data",
    "percentage": "3.7",
    "populations": {
      "All people": "40831396",
      "England & Wales": "34959859",
      "Scotland": "4687680",
      "England": "",
      "Wales": "",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 37867
      },
      {
        "name": "Republic of Ireland",
        "value": 550040
      },
      {
        "name": "Northern Ireland",
        "value": 0
      },
      {
        "name": "British Empire",
        "value": 179392
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 0
      },
      {
        "name": "Canada",
        "value": 0
      },
      {
        "name": "Australia",
        "value": 0
      },
      {
        "name": "New Zealand",
        "value": 0
      },
      {
        "name": "Other Oceania",
        "value": 0
      },
      {
        "name": "Caribbean",
        "value": 1437
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 0
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 58
      },
      {
        "name": "Other Africa",
        "value": 3221
      },
      {
        "name": "Hungary",
        "value": 0
      },
      {
        "name": "Austria-Hungary",
        "value": 17472
      },
      {
        "name": "Belgium",
        "value": 6537
      },
      {
        "name": "France",
        "value": 39229
      },
      {
        "name": "Germany",
        "value": 67623
      },
      {
        "name": "Greece",
        "value": 2035
      },
      {
        "name": "Italy",
        "value": 26686
      },
      {
        "name": "Netherlands",
        "value": 9351
      },
      {
        "name": "Portugal",
        "value": 1639
      },
      {
        "name": "Spain",
        "value": 5338
      },
      {
        "name": "Sweden",
        "value": 7480
      },
      {
        "name": "Malta & Gozo",
        "value": 0
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 76929
      },
      {
        "name": "Czech Republic",
        "value": 0
      },
      {
        "name": "Poland",
        "value": 41622
      },
      {
        "name": "Romania",
        "value": 0
      },
      {
        "name": "Turkey",
        "value": 4019
      },
      {
        "name": "Other Europe",
        "value": 29928
      },
      {
        "name": "Cyprus",
        "value": 0
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 3353
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 1465
      },
      {
        "name": "Malaysia",
        "value": 0
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 1921
      },
      {
        "name": "United States of America",
        "value": 41521
      },
      {
        "name": "South America",
        "value": 5254
      },
      {
        "name": "Other America",
        "value": 3147
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 339091
      }
    ]
  },
  {
    "year": "1921",
    "type": "data",
    "percentage": "3.2",
    "populations": {
      "All people": "42769196",
      "England & Wales": "36586247",
      "Scotland": "4500228",
      "England": "34499643",
      "Wales": "2086604",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 40177
      },
      {
        "name": "Republic of Ireland",
        "value": 369879
      },
      {
        "name": "Northern Ireland",
        "value": 153888
      },
      {
        "name": "British Empire",
        "value": 0
      },
      {
        "name": "Indian Empire",
        "value": 81830
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 4340
      },
      {
        "name": "Canada",
        "value": 35975
      },
      {
        "name": "Australia",
        "value": 28848
      },
      {
        "name": "New Zealand",
        "value": 8269
      },
      {
        "name": "Other Oceania",
        "value": 352
      },
      {
        "name": "Caribbean",
        "value": 9757
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 26591
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 3757
      },
      {
        "name": "Other Africa",
        "value": 6771
      },
      {
        "name": "Hungary",
        "value": 1226
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 13056
      },
      {
        "name": "France",
        "value": 36955
      },
      {
        "name": "Germany",
        "value": 23703
      },
      {
        "name": "Greece",
        "value": 3240
      },
      {
        "name": "Italy",
        "value": 27379
      },
      {
        "name": "Netherlands",
        "value": 9779
      },
      {
        "name": "Portugal",
        "value": 1752
      },
      {
        "name": "Spain",
        "value": 5227
      },
      {
        "name": "Sweden",
        "value": 6288
      },
      {
        "name": "Malta & Gozo",
        "value": 6736
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 70527
      },
      {
        "name": "Czech Republic",
        "value": 1960
      },
      {
        "name": "Poland",
        "value": 43787
      },
      {
        "name": "Romania",
        "value": 5169
      },
      {
        "name": "Turkey",
        "value": 1864
      },
      {
        "name": "Other Europe",
        "value": 36156
      },
      {
        "name": "Cyprus",
        "value": 334
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 5863
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 2617
      },
      {
        "name": "Malaysia",
        "value": 0
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 13058
      },
      {
        "name": "United States of America",
        "value": 50738
      },
      {
        "name": "South America",
        "value": 8520
      },
      {
        "name": "Other America",
        "value": 6079
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 230198
      }
    ]
  },
  {
    "year": "1931",
    "type": "data",
    "percentage": "2.8",
    "populations": {
      "All people": "44795357",
      "England & Wales": "38660674",
      "Scotland": "4862514",
      "England": "36016183",
      "Wales": "2644491",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 37308
      },
      {
        "name": "Republic of Ireland",
        "value": 367424
      },
      {
        "name": "Northern Ireland",
        "value": 137961
      },
      {
        "name": "British Empire",
        "value": 0
      },
      {
        "name": "Indian Empire",
        "value": 95311
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 5025
      },
      {
        "name": "Canada",
        "value": 38302
      },
      {
        "name": "Australia",
        "value": 30637
      },
      {
        "name": "New Zealand",
        "value": 9490
      },
      {
        "name": "Other Oceania",
        "value": 525
      },
      {
        "name": "Caribbean",
        "value": 9128
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 26575
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 5578
      },
      {
        "name": "Other Africa",
        "value": 1490
      },
      {
        "name": "Hungary",
        "value": 1152
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 10356
      },
      {
        "name": "France",
        "value": 30075
      },
      {
        "name": "Germany",
        "value": 29202
      },
      {
        "name": "Greece",
        "value": 2258
      },
      {
        "name": "Italy",
        "value": 7303
      },
      {
        "name": "Netherlands",
        "value": 8537
      },
      {
        "name": "Portugal",
        "value": 1212
      },
      {
        "name": "Spain",
        "value": 4777
      },
      {
        "name": "Sweden",
        "value": 4878
      },
      {
        "name": "Malta & Gozo",
        "value": 8418
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 42314
      },
      {
        "name": "Czech Republic",
        "value": 1982
      },
      {
        "name": "Poland",
        "value": 44883
      },
      {
        "name": "Romania",
        "value": 4666
      },
      {
        "name": "Turkey",
        "value": 2244
      },
      {
        "name": "Other Europe",
        "value": 48986
      },
      {
        "name": "Cyprus",
        "value": 1078
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 6733
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 2422
      },
      {
        "name": "Malaysia",
        "value": 5140
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 10550
      },
      {
        "name": "United States of America",
        "value": 44592
      },
      {
        "name": "South America",
        "value": 8916
      },
      {
        "name": "Other America",
        "value": 6259
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 162619
      }
    ]
  },
  {
    "year": "1941",
    "type": "data",
    "percentage": "3.7",
    "populations": {
      "All people": "46824830",
      "England & Wales": "40006313.5",
      "Scotland": "5069574.5",
      "England": "37278869.5",
      "Wales": "2727444",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 38157
      },
      {
        "name": "Republic of Ireland",
        "value": 452566
      },
      {
        "name": "Northern Ireland",
        "value": 158140
      },
      {
        "name": "British Empire",
        "value": 0
      },
      {
        "name": "Indian Empire",
        "value": 112960
      },
      {
        "name": "India",
        "value": 0
      },
      {
        "name": "Pakistan",
        "value": 0
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 5736
      },
      {
        "name": "Canada",
        "value": 46010
      },
      {
        "name": "Australia",
        "value": 31952
      },
      {
        "name": "New Zealand",
        "value": 11010
      },
      {
        "name": "Other Oceania",
        "value": 352
      },
      {
        "name": "Caribbean",
        "value": 11538
      },
      {
        "name": "Kenya",
        "value": 0
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 28367
      },
      {
        "name": "Tanzania",
        "value": 0
      },
      {
        "name": "Uganda",
        "value": 0
      },
      {
        "name": "Zambia",
        "value": 0
      },
      {
        "name": "Zimbabwe",
        "value": 0
      },
      {
        "name": "Ghana",
        "value": 0
      },
      {
        "name": "Nigeria",
        "value": 0
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 9235
      },
      {
        "name": "Other Africa",
        "value": 5268
      },
      {
        "name": "Hungary",
        "value": 4636
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 13240
      },
      {
        "name": "France",
        "value": 30848
      },
      {
        "name": "Germany",
        "value": 66299
      },
      {
        "name": "Greece",
        "value": 3616
      },
      {
        "name": "Italy",
        "value": 22865
      },
      {
        "name": "Netherlands",
        "value": 11200
      },
      {
        "name": "Portugal",
        "value": 1327
      },
      {
        "name": "Spain",
        "value": 5875
      },
      {
        "name": "Sweden",
        "value": 4154
      },
      {
        "name": "Malta & Gozo",
        "value": 11741
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 62140
      },
      {
        "name": "Czech Republic",
        "value": 7668
      },
      {
        "name": "Poland",
        "value": 103611
      },
      {
        "name": "Romania",
        "value": 5290
      },
      {
        "name": "Turkey",
        "value": 2835
      },
      {
        "name": "Other Europe",
        "value": 63171
      },
      {
        "name": "Cyprus",
        "value": 5711
      },
      {
        "name": "Iran",
        "value": 0
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 0
      },
      {
        "name": "China",
        "value": 8096
      },
      {
        "name": "Hong Kong",
        "value": 0
      },
      {
        "name": "Japan",
        "value": 1960
      },
      {
        "name": "Malaysia",
        "value": 4964
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 15081
      },
      {
        "name": "United States of America",
        "value": 55332
      },
      {
        "name": "South America",
        "value": 9892
      },
      {
        "name": "Other America",
        "value": 5540
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 296689
      }
    ]
  },
  {
    "year": "1951",
    "type": "data",
    "percentage": "4.6",
    "populations": {
      "All people": "48854303",
      "England & Wales": "41351953",
      "Scotland": "5276635",
      "England": "38541556",
      "Wales": "2810397",
      "UK part not specified": ""
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 39007
      },
      {
        "name": "Republic of Ireland",
        "value": 537709
      },
      {
        "name": "Northern Ireland",
        "value": 178319
      },
      {
        "name": "British Empire",
        "value": 0
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 118758
      },
      {
        "name": "Pakistan",
        "value": 11851
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 6447
      },
      {
        "name": "Canada",
        "value": 53717
      },
      {
        "name": "Australia",
        "value": 33267
      },
      {
        "name": "New Zealand",
        "value": 12529
      },
      {
        "name": "Other Oceania",
        "value": 178
      },
      {
        "name": "Caribbean",
        "value": 13948
      },
      {
        "name": "Kenya",
        "value": 2420
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 30158
      },
      {
        "name": "Tanzania",
        "value": 1014
      },
      {
        "name": "Uganda",
        "value": 736
      },
      {
        "name": "Zambia",
        "value": 1951
      },
      {
        "name": "Zimbabwe",
        "value": 483
      },
      {
        "name": "Ghana",
        "value": 1275
      },
      {
        "name": "Nigeria",
        "value": 3051
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 12891
      },
      {
        "name": "Other Africa",
        "value": 9046
      },
      {
        "name": "Hungary",
        "value": 8120
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 16124
      },
      {
        "name": "France",
        "value": 31621
      },
      {
        "name": "Germany",
        "value": 103395
      },
      {
        "name": "Greece",
        "value": 4973
      },
      {
        "name": "Italy",
        "value": 38427
      },
      {
        "name": "Netherlands",
        "value": 13862
      },
      {
        "name": "Portugal",
        "value": 1441
      },
      {
        "name": "Spain",
        "value": 6973
      },
      {
        "name": "Sweden",
        "value": 3429
      },
      {
        "name": "Malta & Gozo",
        "value": 15063
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 81965
      },
      {
        "name": "Czech Republic",
        "value": 13353
      },
      {
        "name": "Poland",
        "value": 162339
      },
      {
        "name": "Romania",
        "value": 5914
      },
      {
        "name": "Turkey",
        "value": 3426
      },
      {
        "name": "Other Europe",
        "value": 77356
      },
      {
        "name": "Cyprus",
        "value": 10343
      },
      {
        "name": "Iran",
        "value": 1776
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 4276
      },
      {
        "name": "China",
        "value": 9458
      },
      {
        "name": "Hong Kong",
        "value": 3459
      },
      {
        "name": "Japan",
        "value": 1497
      },
      {
        "name": "Malaysia",
        "value": 4788
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 0
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 19612
      },
      {
        "name": "United States of America",
        "value": 66071
      },
      {
        "name": "South America",
        "value": 10868
      },
      {
        "name": "Other America",
        "value": 4821
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 430758
      }
    ]
  },
  {
    "year": "1961",
    "type": "data",
    "percentage": "5.2",
    "populations": {
      "All people": "51283892",
      "England & Wales": "43139202",
      "Scotland": "5410391",
      "England": "40216089",
      "Wales": "2831745",
      "UK part not specified": "91368"
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 33531
      },
      {
        "name": "Republic of Ireland",
        "value": 726121
      },
      {
        "name": "Northern Ireland",
        "value": 224857
      },
      {
        "name": "British Empire",
        "value": 0
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 165869
      },
      {
        "name": "Pakistan",
        "value": 31861
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 9617
      },
      {
        "name": "Canada",
        "value": 56611
      },
      {
        "name": "Australia",
        "value": 39263
      },
      {
        "name": "New Zealand",
        "value": 14455
      },
      {
        "name": "Other Oceania",
        "value": 1167
      },
      {
        "name": "Caribbean",
        "value": 161988
      },
      {
        "name": "Kenya",
        "value": 6741
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 40263
      },
      {
        "name": "Tanzania",
        "value": 2401
      },
      {
        "name": "Uganda",
        "value": 2217
      },
      {
        "name": "Zambia",
        "value": 3846
      },
      {
        "name": "Zimbabwe",
        "value": 6713
      },
      {
        "name": "Ghana",
        "value": 4854
      },
      {
        "name": "Nigeria",
        "value": 13676
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 21281
      },
      {
        "name": "Other Africa",
        "value": 14485
      },
      {
        "name": "Hungary",
        "value": 18272
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 15499
      },
      {
        "name": "France",
        "value": 31495
      },
      {
        "name": "Germany",
        "value": 127912
      },
      {
        "name": "Greece",
        "value": 7268
      },
      {
        "name": "Italy",
        "value": 87243
      },
      {
        "name": "Netherlands",
        "value": 16479
      },
      {
        "name": "Portugal",
        "value": 2992
      },
      {
        "name": "Spain",
        "value": 21363
      },
      {
        "name": "Sweden",
        "value": 3783
      },
      {
        "name": "Malta & Gozo",
        "value": 25742
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 56867
      },
      {
        "name": "Czech Republic",
        "value": 10318
      },
      {
        "name": "Poland",
        "value": 127246
      },
      {
        "name": "Romania",
        "value": 4608
      },
      {
        "name": "Turkey",
        "value": 3978
      },
      {
        "name": "Other Europe",
        "value": 81856
      },
      {
        "name": "Cyprus",
        "value": 42283
      },
      {
        "name": "Iran",
        "value": 4035
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 12155
      },
      {
        "name": "China",
        "value": 9852
      },
      {
        "name": "Hong Kong",
        "value": 10878
      },
      {
        "name": "Japan",
        "value": 2559
      },
      {
        "name": "Malaysia",
        "value": 10429
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 10447
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 19866
      },
      {
        "name": "United States of America",
        "value": 102295
      },
      {
        "name": "South America",
        "value": 22199
      },
      {
        "name": "Other America",
        "value": 6527
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 163405
      }
    ]
  },
  {
    "year": "1971",
    "type": "data",
    "percentage": "6.4",
    "populations": {
      "All people": "53978540",
      "England & Wales": "44855010",
      "Scotland": "5534970",
      "England": "41959930",
      "Wales": "2893790",
      "UK part not specified": "1290"
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 31205
      },
      {
        "name": "Republic of Ireland",
        "value": 709235
      },
      {
        "name": "Northern Ireland",
        "value": 248595
      },
      {
        "name": "British Empire",
        "value": 0
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 321995
      },
      {
        "name": "Pakistan",
        "value": 139935
      },
      {
        "name": "Bangladesh",
        "value": 0
      },
      {
        "name": "Sri Lanka",
        "value": 17040
      },
      {
        "name": "Canada",
        "value": 64665
      },
      {
        "name": "Australia",
        "value": 57000
      },
      {
        "name": "New Zealand",
        "value": 21155
      },
      {
        "name": "Other Oceania",
        "value": 3480
      },
      {
        "name": "Caribbean",
        "value": 283000
      },
      {
        "name": "Kenya",
        "value": 59500
      },
      {
        "name": "Mauritius",
        "value": 0
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 45825
      },
      {
        "name": "Tanzania",
        "value": 3409
      },
      {
        "name": "Uganda",
        "value": 12590
      },
      {
        "name": "Zambia",
        "value": 5740
      },
      {
        "name": "Zimbabwe",
        "value": 7905
      },
      {
        "name": "Ghana",
        "value": 11215
      },
      {
        "name": "Nigeria",
        "value": 28565
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 30510
      },
      {
        "name": "Other Africa",
        "value": 20901
      },
      {
        "name": "Hungary",
        "value": 15910
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 15245
      },
      {
        "name": "France",
        "value": 35910
      },
      {
        "name": "Germany",
        "value": 157680
      },
      {
        "name": "Greece",
        "value": 9690
      },
      {
        "name": "Italy",
        "value": 108980
      },
      {
        "name": "Netherlands",
        "value": 19465
      },
      {
        "name": "Portugal",
        "value": 9751
      },
      {
        "name": "Spain",
        "value": 49470
      },
      {
        "name": "Sweden",
        "value": 5409
      },
      {
        "name": "Malta & Gozo",
        "value": 33840
      },
      {
        "name": "Bulgaria",
        "value": 0
      },
      {
        "name": "Russia",
        "value": 48095
      },
      {
        "name": "Czech Republic",
        "value": 10077
      },
      {
        "name": "Poland",
        "value": 110925
      },
      {
        "name": "Romania",
        "value": 4003
      },
      {
        "name": "Turkey",
        "value": 6615
      },
      {
        "name": "Other Europe",
        "value": 70979
      },
      {
        "name": "Cyprus",
        "value": 73295
      },
      {
        "name": "Iran",
        "value": 8205
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 29660
      },
      {
        "name": "China",
        "value": 13495
      },
      {
        "name": "Hong Kong",
        "value": 29520
      },
      {
        "name": "Japan",
        "value": 7424
      },
      {
        "name": "Malaysia",
        "value": 25685
      },
      {
        "name": "Philippines",
        "value": 0
      },
      {
        "name": "Singapore",
        "value": 27335
      },
      {
        "name": "Vietnam",
        "value": 0
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 29109
      },
      {
        "name": "United States of America",
        "value": 110590
      },
      {
        "name": "South America",
        "value": 21070
      },
      {
        "name": "Other America",
        "value": 20950
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 224867
      }
    ]
  },
  {
    "year": "1981",
    "type": "data",
    "percentage": "6.8",
    "populations": {
      "All people": "53556911",
      "England & Wales": "44623121",
      "Scotland": "5300896",
      "England": "41850284",
      "Wales": "2770759",
      "UK part not specified": "2078"
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 30100
      },
      {
        "name": "Republic of Ireland",
        "value": 607428
      },
      {
        "name": "Northern Ireland",
        "value": 242969
      },
      {
        "name": "British Empire",
        "value": 0
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 391874
      },
      {
        "name": "Pakistan",
        "value": 188198
      },
      {
        "name": "Bangladesh",
        "value": 48517
      },
      {
        "name": "Sri Lanka",
        "value": 26091
      },
      {
        "name": "Canada",
        "value": 62051
      },
      {
        "name": "Australia",
        "value": 61916
      },
      {
        "name": "New Zealand",
        "value": 28780
      },
      {
        "name": "Other Oceania",
        "value": 6647
      },
      {
        "name": "Caribbean",
        "value": 274623
      },
      {
        "name": "Kenya",
        "value": 102144
      },
      {
        "name": "Mauritius",
        "value": 21062
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 54207
      },
      {
        "name": "Tanzania",
        "value": 27151
      },
      {
        "name": "Uganda",
        "value": 45937
      },
      {
        "name": "Zambia",
        "value": 12558
      },
      {
        "name": "Zimbabwe",
        "value": 16330
      },
      {
        "name": "Ghana",
        "value": 16887
      },
      {
        "name": "Nigeria",
        "value": 31310
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 39739
      },
      {
        "name": "Other Africa",
        "value": 33045
      },
      {
        "name": "Hungary",
        "value": 14235
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 14834
      },
      {
        "name": "France",
        "value": 39052
      },
      {
        "name": "Germany",
        "value": 181008
      },
      {
        "name": "Greece",
        "value": 12112
      },
      {
        "name": "Italy",
        "value": 97848
      },
      {
        "name": "Netherlands",
        "value": 23761
      },
      {
        "name": "Portugal",
        "value": 16510
      },
      {
        "name": "Spain",
        "value": 40041
      },
      {
        "name": "Sweden",
        "value": 7034
      },
      {
        "name": "Malta & Gozo",
        "value": 34007
      },
      {
        "name": "Bulgaria",
        "value": 691
      },
      {
        "name": "Russia",
        "value": 35900
      },
      {
        "name": "Czech Republic",
        "value": 9836
      },
      {
        "name": "Poland",
        "value": 93369
      },
      {
        "name": "Romania",
        "value": 3398
      },
      {
        "name": "Turkey",
        "value": 11848
      },
      {
        "name": "Other Europe",
        "value": 82424
      },
      {
        "name": "Cyprus",
        "value": 84327
      },
      {
        "name": "Iran",
        "value": 28068
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 43972
      },
      {
        "name": "China",
        "value": 17569
      },
      {
        "name": "Hong Kong",
        "value": 58917
      },
      {
        "name": "Japan",
        "value": 12289
      },
      {
        "name": "Malaysia",
        "value": 45430
      },
      {
        "name": "Philippines",
        "value": 11897
      },
      {
        "name": "Singapore",
        "value": 32447
      },
      {
        "name": "Vietnam",
        "value": 13296
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 24395
      },
      {
        "name": "United States of America",
        "value": 118079
      },
      {
        "name": "South America",
        "value": 48563
      },
      {
        "name": "Other America",
        "value": 4166
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 938
      }
    ]
  },
  {
    "year": "1991",
    "type": "data",
    "percentage": "7.3",
    "populations": {
      "All people": "54888744",
      "England & Wales": "45645212",
      "Scotland": "5221094",
      "England": "42897376",
      "Wales": "2747836",
      "UK part not specified": "5300"
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 30277
      },
      {
        "name": "Republic of Ireland",
        "value": 592283
      },
      {
        "name": "Northern Ireland",
        "value": 241203
      },
      {
        "name": "British Empire",
        "value": 0
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 409130
      },
      {
        "name": "Pakistan",
        "value": 234164
      },
      {
        "name": "Bangladesh",
        "value": 104925
      },
      {
        "name": "Sri Lanka",
        "value": 39402
      },
      {
        "name": "Canada",
        "value": 63176
      },
      {
        "name": "Australia",
        "value": 73336
      },
      {
        "name": "New Zealand",
        "value": 41203
      },
      {
        "name": "Other Oceania",
        "value": 7473
      },
      {
        "name": "Caribbean",
        "value": 266902
      },
      {
        "name": "Kenya",
        "value": 112441
      },
      {
        "name": "Mauritius",
        "value": 23584
      },
      {
        "name": "Somalia",
        "value": 0
      },
      {
        "name": "South Africa",
        "value": 67918
      },
      {
        "name": "Tanzania",
        "value": 29677
      },
      {
        "name": "Uganda",
        "value": 47958
      },
      {
        "name": "Zambia",
        "value": 16783
      },
      {
        "name": "Zimbabwe",
        "value": 21427
      },
      {
        "name": "Ghana",
        "value": 32528
      },
      {
        "name": "Nigeria",
        "value": 47201
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 0
      },
      {
        "name": "North Africa",
        "value": 44561
      },
      {
        "name": "Other Africa",
        "value": 57445
      },
      {
        "name": "Hungary",
        "value": 12293
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 16528
      },
      {
        "name": "France",
        "value": 53371
      },
      {
        "name": "Germany",
        "value": 215113
      },
      {
        "name": "Greece",
        "value": 14459
      },
      {
        "name": "Italy",
        "value": 91011
      },
      {
        "name": "Netherlands",
        "value": 29653
      },
      {
        "name": "Portugal",
        "value": 19904
      },
      {
        "name": "Spain",
        "value": 38606
      },
      {
        "name": "Sweden",
        "value": 11001
      },
      {
        "name": "Malta & Gozo",
        "value": 31252
      },
      {
        "name": "Bulgaria",
        "value": 1739
      },
      {
        "name": "Russia",
        "value": 27108
      },
      {
        "name": "Czech Republic",
        "value": 8696
      },
      {
        "name": "Poland",
        "value": 73951
      },
      {
        "name": "Romania",
        "value": 4019
      },
      {
        "name": "Turkey",
        "value": 26757
      },
      {
        "name": "Other Europe",
        "value": 88747
      },
      {
        "name": "Cyprus",
        "value": 78191
      },
      {
        "name": "Iran",
        "value": 32158
      },
      {
        "name": "Iraq",
        "value": 0
      },
      {
        "name": "Other Middle East",
        "value": 69401
      },
      {
        "name": "China",
        "value": 23846
      },
      {
        "name": "Hong Kong",
        "value": 72884
      },
      {
        "name": "Japan",
        "value": 28247
      },
      {
        "name": "Malaysia",
        "value": 43608
      },
      {
        "name": "Philippines",
        "value": 21789
      },
      {
        "name": "Singapore",
        "value": 33751
      },
      {
        "name": "Vietnam",
        "value": 20116
      },
      {
        "name": "Afghanistan",
        "value": 0
      },
      {
        "name": "Other Asia",
        "value": 35310
      },
      {
        "name": "United States of America",
        "value": 143590
      },
      {
        "name": "South America",
        "value": 34518
      },
      {
        "name": "Other America",
        "value": 4512
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 3247
      }
    ]
  },
  {
    "year": "2001",
    "type": "data",
    "percentage": "9.3",
    "populations": {
      "All people": "57103927",
      "England & Wales": "46790982",
      "Scotland": "5229366",
      "England": "43967372",
      "Wales": "2815088",
      "UK part not specified": "8522"
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 30455
      },
      {
        "name": "Republic of Ireland",
        "value": 494836
      },
      {
        "name": "Northern Ireland",
        "value": 256503
      },
      {
        "name": "British Empire",
        "value": 0
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 466464
      },
      {
        "name": "Pakistan",
        "value": 320843
      },
      {
        "name": "Bangladesh",
        "value": 154221
      },
      {
        "name": "Sri Lanka",
        "value": 67874
      },
      {
        "name": "Canada",
        "value": 70069
      },
      {
        "name": "Australia",
        "value": 106327
      },
      {
        "name": "New Zealand",
        "value": 57838
      },
      {
        "name": "Other Oceania",
        "value": 5585
      },
      {
        "name": "Caribbean",
        "value": 254789
      },
      {
        "name": "Kenya",
        "value": 129405
      },
      {
        "name": "Mauritius",
        "value": 23584
      },
      {
        "name": "Somalia",
        "value": 43532
      },
      {
        "name": "South Africa",
        "value": 140104
      },
      {
        "name": "Tanzania",
        "value": 29677
      },
      {
        "name": "Uganda",
        "value": 49979
      },
      {
        "name": "Zambia",
        "value": 16783
      },
      {
        "name": "Zimbabwe",
        "value": 49235
      },
      {
        "name": "Ghana",
        "value": 48352
      },
      {
        "name": "Nigeria",
        "value": 88211
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 8560
      },
      {
        "name": "North Africa",
        "value": 71837
      },
      {
        "name": "Other Africa",
        "value": 261250
      },
      {
        "name": "Hungary",
        "value": 12293
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 21526
      },
      {
        "name": "France",
        "value": 94309
      },
      {
        "name": "Germany",
        "value": 262257
      },
      {
        "name": "Greece",
        "value": 35077
      },
      {
        "name": "Italy",
        "value": 106956
      },
      {
        "name": "Netherlands",
        "value": 40040
      },
      {
        "name": "Portugal",
        "value": 36387
      },
      {
        "name": "Spain",
        "value": 54118
      },
      {
        "name": "Sweden",
        "value": 22408
      },
      {
        "name": "Malta & Gozo",
        "value": 31252
      },
      {
        "name": "Bulgaria",
        "value": 1739
      },
      {
        "name": "Russia",
        "value": 43095
      },
      {
        "name": "Czech Republic",
        "value": 12181
      },
      {
        "name": "Poland",
        "value": 60612
      },
      {
        "name": "Romania",
        "value": 7530
      },
      {
        "name": "Turkey",
        "value": 53935
      },
      {
        "name": "Other Europe",
        "value": 229617
      },
      {
        "name": "Cyprus",
        "value": 77296
      },
      {
        "name": "Iran",
        "value": 42355
      },
      {
        "name": "Iraq",
        "value": 32189
      },
      {
        "name": "Other Middle East",
        "value": 83834
      },
      {
        "name": "China",
        "value": 51788
      },
      {
        "name": "Hong Kong",
        "value": 94699
      },
      {
        "name": "Japan",
        "value": 37419
      },
      {
        "name": "Malaysia",
        "value": 49304
      },
      {
        "name": "Philippines",
        "value": 47743
      },
      {
        "name": "Singapore",
        "value": 40203
      },
      {
        "name": "Vietnam",
        "value": 20116
      },
      {
        "name": "Afghanistan",
        "value": 14861
      },
      {
        "name": "Other Asia",
        "value": 87999
      },
      {
        "name": "United States of America",
        "value": 155065
      },
      {
        "name": "South America",
        "value": 76403
      },
      {
        "name": "Other America",
        "value": 8868
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 41993
      }
    ]
  },
  {
    "year": "2011",
    "type": "data",
    "percentage": "13.1",
    "populations": {
      "All people": "61371315",
      "England & Wales": "48092349",
      "Scotland": "5145102",
      "England": "45342344",
      "Wales": "2750005",
      "UK part not specified": "7927"
    },
    "from": [
      {
        "name": "Channel Islands & Isle of Man",
        "value": 27713
      },
      {
        "name": "Republic of Ireland",
        "value": 430309
      },
      {
        "name": "Northern Ireland",
        "value": 251643
      },
      {
        "name": "British Empire",
        "value": 0
      },
      {
        "name": "Indian Empire",
        "value": 0
      },
      {
        "name": "India",
        "value": 717637
      },
      {
        "name": "Pakistan",
        "value": 502176
      },
      {
        "name": "Bangladesh",
        "value": 213731
      },
      {
        "name": "Sri Lanka",
        "value": 120000
      },
      {
        "name": "Canada",
        "value": 84000
      },
      {
        "name": "Australia",
        "value": 124566
      },
      {
        "name": "New Zealand",
        "value": 58000
      },
      {
        "name": "Other Oceania",
        "value": 13215
      },
      {
        "name": "Caribbean",
        "value": 266179
      },
      {
        "name": "Kenya",
        "value": 140235
      },
      {
        "name": "Mauritius",
        "value": 42000
      },
      {
        "name": "Somalia",
        "value": 102000
      },
      {
        "name": "South Africa",
        "value": 201630
      },
      {
        "name": "Tanzania",
        "value": 35000
      },
      {
        "name": "Uganda",
        "value": 52000
      },
      {
        "name": "Zambia",
        "value": 35000
      },
      {
        "name": "Zimbabwe",
        "value": 123014
      },
      {
        "name": "Ghana",
        "value": 80000
      },
      {
        "name": "Nigeria",
        "value": 200641
      },
      {
        "name": "Democratic Republic of Congo",
        "value": 20000
      },
      {
        "name": "North Africa",
        "value": 119348
      },
      {
        "name": "Other Africa",
        "value": 208491
      },
      {
        "name": "Hungary",
        "value": 48000
      },
      {
        "name": "Austria-Hungary",
        "value": 0
      },
      {
        "name": "Belgium",
        "value": 29000
      },
      {
        "name": "France",
        "value": 136951
      },
      {
        "name": "Germany",
        "value": 295838
      },
      {
        "name": "Greece",
        "value": 36000
      },
      {
        "name": "Italy",
        "value": 140667
      },
      {
        "name": "Netherlands",
        "value": 56000
      },
      {
        "name": "Portugal",
        "value": 84000
      },
      {
        "name": "Spain",
        "value": 84092
      },
      {
        "name": "Sweden",
        "value": 29000
      },
      {
        "name": "Malta & Gozo",
        "value": 26000
      },
      {
        "name": "Bulgaria",
        "value": 47000
      },
      {
        "name": "Russia",
        "value": 41000
      },
      {
        "name": "Czech Republic",
        "value": 33000
      },
      {
        "name": "Poland",
        "value": 634352
      },
      {
        "name": "Romania",
        "value": 82074
      },
      {
        "name": "Turkey",
        "value": 93539
      },
      {
        "name": "Other Europe",
        "value": 566163
      },
      {
        "name": "Cyprus",
        "value": 54000
      },
      {
        "name": "Iran",
        "value": 84453
      },
      {
        "name": "Iraq",
        "value": 63000
      },
      {
        "name": "Other Middle East",
        "value": 159215
      },
      {
        "name": "China",
        "value": 167836
      },
      {
        "name": "Hong Kong",
        "value": 109827
      },
      {
        "name": "Japan",
        "value": 43000
      },
      {
        "name": "Malaysia",
        "value": 62000
      },
      {
        "name": "Philippines",
        "value": 126889
      },
      {
        "name": "Singapore",
        "value": 38000
      },
      {
        "name": "Vietnam",
        "value": 26000
      },
      {
        "name": "Afghanistan",
        "value": 54000
      },
      {
        "name": "Other Asia",
        "value": 79837
      },
      {
        "name": "United States of America",
        "value": 193104
      },
      {
        "name": "South America",
        "value": 149573
      },
      {
        "name": "Other America",
        "value": 13898
      },
      {
        "name": "At sea/Elsewhere/Not stated",
        "value": 106
      }
    ]
  }
]

var populations1841 = migrationData.filter(d => d.year == "1841")
                                   .map(d => d.from)[0]
                                   .filter(d => parseInt(d.value) > 0)
                                   .sort((d1, d2) => d1.value - d2.value)
                                   .reverse()

var slugify = function(text) {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g,'')
    .replace(/ +/g,'-');
}

// Generate unique colours for all countries
// -- sum char values of country name, then
// -- modulo 360 for use as hsl hue.

var countryColor = function(name) {
  var countryname = slugify(name);
  var charTotal = 0;
  for (var i = countryname.length - 1; i >= 0; i--) {
    charTotal += countryname.charCodeAt(i);
  }
  return charTotal % 360;
}

$.each(migrationData, function(i,year) {

  $.each(year.from, function(j,country) {
    country['hue'] = countryColor(country.name);
  })

})

var maxPopulation = parseFloat(migrationData[migrationData.length-1].populations['All people']);

// Calculate *migration* from *uk population by birthplace* (from)
$.each(migrationData, function(i,year) {

  year['migration'] = [];

  $.each(year.from, function(j,country) {

    var diff;

    try {
      diff = country.value - migrationData[i-1].from[j].value;
    } catch (e) {
      diff = 0;
    }

    year.migration.push({name : country.name, value : diff, hue: country.hue});

  })

  var previous = i!=0 ? i-1 : 0;
  year['netMigration'] = netMigrationData.filter(n => n[0] == parseInt(year.year)).map(n => !!n ? n[1] : 0)[0]

})

var migrationEvents = [
{"year":"1845","attribution":"By James Mahony [Public domain], via Wikimedia Commons","image":"1845.png","type":"event","end":"1852","title":"Irish Potato Famine", "text":"Irish Potato Famine prompts mass emigration of 1 million people from Ireland: many come to Britain."},
{"year":"1905","attribution":"INTERFOTO / Alamy Stock Photo","image":"1905.png","type":"event","end":"","title":"Aliens Act", "text":"Aliens Act introduces first immigration controls to Britain, prompted by arrival of Jews fleeing massacres in tsarist Russia."},
{"year":"1939","attribution":"By Ministry of Information Photo Division Photographer [Public domain], via Wikimedia Commons","image":"1939.png","type":"event","end":"1945","title":"World War II", "text":"Second World War displaces millions of people. Mass movement of migrant labour to Britain to assist with post-war reconstruction. New arrivals include 100,000 Jewish refugees, a small number of German prisoners of war, a large number of refugees from the Communist bloc, especially Poland and Hungary, as well as Irish and Italian labourers."},
{"year":"1945","attribution":" Trinity Mirror / Mirrorpix / Alamy Stock Photo","image":"1945.png","type":"event","end":"1982","title":"Australian Migration", "text":"UK citizens are encouraged to relocate to Australia to populate the country and increase the labour force. Over 1.5 million people make the trip."},
{"year":"1947","attribution":"Dinodia Photos / Alamy Stock Photo","image":"1947.png","type":"event","end":"","title":"Indian Independence Act", "text":"Indian Independence Act partitions British India into the two new independent countries of India and Pakistan. People of both countries begin to emigrate to Britain."},
{"year":"1948","attribution":"By Royal Navy official photographer [Public domain], via Wikimedia Commons","image":"1948.png","type":"event","end":"","title":"British Nationality Act", "text":"British Nationality Act makes anyone previously classed as a British subject a Commonwealth Citizen of the United Kingdom and Colonies, with freedom to enter and settle in Britain. The Empire Windrush liner leaves Kingston, Jamaica for Tilbury in Essex with almost 500 West Indians on board. Significant migration from the West Indies and Indian subcontinent follows."},
{"year":"1952","attribution":"Trinity Mirror / Mirrorpix / Alamy Stock Photo","image":"1952.png","type":"event","end":"","title":"West Indians arrive in Britain", "text":"US imposes heavy restrictions on West Indian immigration, leading to an increase in West Indian migration to Britain. Between 1953 and 1959, 195,000 West Indians arrive in Britain, and a further 194,000 in 1960-61. Many find jobs in industry, the armed forces and the NHS."},
{"year":"1962","attribution":"Keystone Pictures USA / Alamy Stock Photo","image":"1962.png","type":"event","end":"","title":"Commonwealth Immigrants Act", "text":"Commonwealth Immigrants Act requires Commonwealth citizens without British passports to apply for work vouchers that are subject to quotas. Migration spikes in 1961 as people rush to enter before the rules are tightened."},
{"year":"1971","attribution":"Indian Navy [CC BY 2.5], via Wikimedia Commons","image":"1971.png","type":"event","end":"","title":"Bangladeshi Independence", "text":"Bangladesh emerges as an independent nation after conflict with Pakistan. Emigration from Bangladesh to Britain increases as the new state endures famine, natural disasters and widespread poverty, as well as political turmoil and military coups."},
{"year":"1972","attribution":"Archives New Zealand [CC BY 2.0], via Wikimedia Commons","image":"1972.png","type":"event","end":"","title":"Asian Minority", "text":"Ugandan President Idi Amin expels his country’s Asian minority. Many are citizens of the United Kingdom and Colonies, and 27,200 emigrate to the UK."},
{"year":"1973","attribution":"© The University of Edinburgh CC BY SA 2016","image":"1973-0-EEC.png","type":"event","end":"","title":"UK joins the EEC", "text":"UK joins the European Economic Community (EEC), the forerunner to the European Union, which permits the free movement of workers throughout the region."},
{"year":"1973","attribution":"Keystone Pictures USA / Alamy Stock Photo","image":"1973-1-Recession.png","type":"event","end":"1976","title":"UK Recession", "text":"Recession in UK economy, miners’ strike, rising unemployment and inflation peaking at 26%. Difficult economic conditions can deter immigrants from coming to the UK and prompt greater emigration."},
{"year":"1980","attribution":"By Hans van Dijk / Anefo [CC BY-SA 3.0 nl], via Wikimedia Commons","image":"1980-1-Recession.png","type":"event","end":"","title":"Second UK Recession", "text":"Recession in the UK economy, with inflation reaching 20% and increased unemployment. Difficult economic conditions can deter immigrants from coming to the UK and prompt greater emigration."},
{"year":"1980","attribution":"Jeff Morgan 01 / Alamy Stock Photo","image":"1980-0-Zimbabwe.png","type":"event","end":"","title":"Zimbabwean Independence", "text":"Creation of Zimbabwe as independent country, ruled by Robert Mugabe. The country’s white citizens lose most of their former privileges. Between 1980 and 1990 about two-thirds of white Zimbabweans emigrate, and nearly 30% of them come to the UK and Ireland, with more to follow after 1999."},
{"year":"1988","attribution":"wronaphoto.com / Alamy Stock Photo","image":"1988.png","type":"event","end":"","title":"Immigration Act", "text":"Immigration Act ensures that workers with freedom of movement in the European Economic Community (EEC) do not need permission to enter or remain in the UK."},
{"year":"1990","attribution":"RichardBakerStreetPhotography / Alamy Stock Photo","image":"1990.png","type":"event","end":"","title":"Third UK Recession", "text":"A third UK recession in three decades. Interest rates double in a year, reaching 15% in 1989; unemployment rises above 3 million and house repossessions hit record levels. Difficult economic conditions can deter immigrants from coming to the UK and prompt greater emigration from this country."},
{"year":"1993","attribution":"Lander Loeckx / Alamy Stock Photo","image":"1993.png","type":"event","end":"","title":"Maastricht Treaty", "text":"Maastricht Treaty establishes the European Union (EU), giving citizenship to citizens of all member states, not just workers. This means all EU nationals can live wherever they like within the EU."},
{"year":"1997","attribution":"Bob Henry / Alamy Stock Photo","image":"1997.png","type":"event","end":"","title":"Hong Kong Handover", "text":"UK hands sovereignty over Hong Kong back to China. Hong Kong residents retain their British passports, and many move to Britain both before and after the handover. British Citizenship granted to 50,000 families from Hong Kong."},
{"year":"1999","attribution":"Photofusion Picture Library / Alamy Stock Photo","image":"1999.png","type":"event","end":"","title":"Asylum Applications", "text":"Asylum applications to the UK increase around the turn of the century as people flee persecution in Eastern Europe and warzones in Somalia, Sri Lanka and the Middle East. This leads to a number of changes to the UK asylum system, including the removal of benefits and the introduction of citizenship tests."},
{"year":"2004","attribution":"By Europe_countries.svg: Júlio Reis derivative work: Kolja21 (EU25-2004_European_Union_map.svg) [CC BY-SA 2.5], via Wikimedia Commons","image":"2004.png","type":"event","end":"","title":"EU8 join the EEC", "text":"Eight Central and Eastern European countries join the European Union (EU): Czech Republic, Estonia, Hungary, Latvia, Lithuania, Poland, Slovakia and Slovenia, along with Malta and Cyprus. The UK is the only large EU economy to allow free movement of migrants from the ‘EU8’ states, leading to significant immigration from Poland and other countries in eastern and central Europe."},
{"year":"2007","attribution":"Paul Davey / Alamy Stock Photo","image":"2007.png","type":"event","end":"","title":"Romania and Bulgaria join the EU", "text":"Romania and Bulgaria join the European Union, leading to an increase in immigration to Britain from these countries."},
{"year":"2008","attribution":"Andrew Harker / Alamy Stock Photo","image":"2008.png","type":"event","end":"","title":"Global Economic Turndown", "text":"The global economy enters a major downturn. Unemployment rises alongside immigration from European Union (EU) countries, and a points-based immigration system is introduced for migrants from outside the EU."},
{"year":"2016","attribution":"Andrey Kuzmin / Alamy Stock Photo","image":"2016.png","type":"event","end":"","title":"UK Votes for Brexit", "text":"UK votes for ‘Brexit’ – to leave the European Union. The government pledges to cut overall immigration to ‘sustainable levels’, and discussions begin on what effect Brexit will have on migration into and out of the UK."}]

migrationData = migrationData.concat(migrationEvents);

migrationData = migrationData.sort(function(a, b) {
	var year_a = a.year,
		year_b = b.year,
		type_a = a.type,
		type_b = b.type;

	if (year_a - year_b == 0) {
		if (type_a == "event") {
			return -1;
		}
	}

	return (year_a - year_b);
})

// Utility functions

var maxYear = parseInt(migrationData[migrationData.length - 1].year);
var minYear = parseInt(migrationData[0].year);

var getYearRange = function() {
  return maxYear - minYear;
}

var maxImmigration = 0;	
for (var _d in migrationData) {
	var d = migrationData[_d];
	if (d.type == "event") {
		continue
	}
	for (var _country in d.from){
		var country = d.from[_country];
		if (country.value > maxImmigration) {
			maxImmigration = country.value;
		}
	}
}

var getTimelineYearStyle = function(yearObject) {
  
  var style = { left: ((yearObject.year - minYear) / getYearRange()) * 100 + '%' };

  if (yearObject.type == 'data') {
    var proportionalPopulation = parseFloat(yearObject.populations['All people']) / maxPopulation;
    var maxHeightScale = 0.7; // This is a fudge factor to ensure the bar doesn't get too tall for the 'reticle'
    style['height'] = proportionalPopulation * 100 * maxHeightScale + "%";
  } else {
    var end = yearObject.end !== "" ? yearObject.end : yearObject.year ;
    var duration = parseFloat(yearObject.end) - parseFloat(yearObject.year);
    style['width'] = ((end - yearObject.year) / getYearRange()) * 100 + '%';
  }

  return style;
}

var decimalMark = function(num) {
  return parseFloat(num).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

// Viewport scaling

var scaleFactor;

$(window).resize(function () {
  var width = $(window).width();
  if (width < 768) {
    var width = 768;
  }
  scaleFactor = width / 1920;
  $('body').css({transform: "scale(" + scaleFactor + ")"});
});

$(function () {
  $(window).resize();
});

var VueTouch = require('vue-touch')
Vue.use(VueTouch, {name: 'v-touch'})

const audioplay = require('audio-play');
const audioload = require('audio-loader');

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-28388718-4'
})

window.app = new Vue({
  el: '#app',
  data: {
		DISPLAYMODE: {
			ATTRACT: 1,
			TIMELINE: 2,
			FULLDATA: 3,
			NETMIGRATION: 4,
			SWIPING: 5,
      HELP: 6
		},
		mode: 1,
    timer: 0,
    sessionTimer: 0,
    timeout: 120,
    timerIncrementer: null,
		currentYearIndex: 0,
		maxYear: maxYear,
		minYear: minYear,
		migrationData: migrationData,
    populations1841: populations1841,
		maxImmigration: maxImmigration,
    maxPopulation: maxPopulation,
    copy: copy,
    globeInitialised: false,
    showhelp: false,
    slideParams: {},
    parallaxMultiplier: 3,
    audio: {click:     'static/audio/click_positive_01.mp3',
            click_neg: 'static/audio/click_negative_01.mp3',
            create:    'static/audio/create_descendent_01.mp3',
            swipe:     'static/audio/grab_timeline_01.mp3'},
    swipeDistance: 0,
    swipeClickiness: 4,
    created: 0
	},
  mounted () {
    globe.init();
    this.globeInitialised = true;
    setTimeout(function(){
      $('body').removeClass('loading')
      setTimeout(function(){
        $('.loader').remove()
      }, 1000);
    }, 2000);
  },
	computed: {
		currentYear: function() {
    	return this.migrationData[this.currentYearIndex];
    },
    top5: function () {
      var vm = this;

      if (parseInt(vm.currentYear.year) == 1841) {
        return vm.populations1841;
      }
      if ("migration" in vm.currentYear) {
	    var sorted = vm.currentYear.migration.sort(function (a,b) {
	      	var diff = a.value - b.value
		  	return diff;
	      });
	    return sorted.filter(item => item.value > 0).reverse().slice(0,5);
      }
    },
    sortedFrom: function () {
      var vm = this;
      if ("from" in vm.currentYear) {
        var sorted = vm.currentYear.from.sort(function (a,b) {
          return b.value - a.value;
        });
        var data = {labels: sorted.map(s => s.name),
                    datasets: [{data: sorted.map(s => s.value),
                                backgroundColor: sorted.map(s => "hsl(" + countryColor(s.name) + ", 80%, 70%)")}]};
        return data;
      };
    }
	},
	methods: {
    EV: function(action, label, value) {
      if (!action) action = '';
      if (!label) label = '';
      if (!value) value = '';
      this.$ga.event('migration_dashboard', action, label)
      this.resetTimer();
    },
    play: function(sound) {

      switch (sound) {
        case 'click':
          audioload(this.audio.click).then(audioplay);
          break
        case 'click_neg':
          audioload(this.audio.click_neg).then(audioplay);
          break
      }

    },

		slugify: slugify,
    getYearRange: getYearRange,
    getTimelineYearStyle: getTimelineYearStyle,
    decimalMark: decimalMark,
    prev: function() {
      var vm = this;
      if (vm.currentYearIndex > 0) {
        vm.currentYearIndex -= 1;
      }
      return
    },
    next: function() {
      var vm = this;
      if (vm.mode == vm.DISPLAYMODE.TIMELINE && vm.currentYearIndex < vm.migrationData.length - 1) {
        vm.currentYearIndex += 1;
      }
      return;
    },
    getParallax: function(multiplier) {
      var vm = this;
      var directionMultipler = vm.mode == vm.DISPLAYMODE.ATTRACT ? -3 : vm.currentYearIndex;
      var parallax = multiplier * directionMultipler * vm.parallaxMultiplier ;
      return parallax + 'rem';
    },
    incrementTimer: function() {
      var vm = this;
      vm.timer += 1;
      vm.sessionTimer += 1;
      clearTimeout(vm.timerIncrementer);
      vm.timerIncrementer = setTimeout(vm.incrementTimer, 1000);
    },
    resetTimer: function() {
      this.timer = 0;
      this.incrementTimer();
    },
    onTimelinePanStart: function(ev) {
      var currentMatrix = $(ev.target).css('transform');
      currentMatrix = currentMatrix == "none" ? "matrix\(1, 0, 0, 1, 0, 0)" : currentMatrix;
      this.slideParams.offset = parseInt(currentMatrix.replace(/matrix\(1, ?0, ?0, ?1, ?([-\.\d]*?), ?0\)/g, `$1`));
      $('.timeline__slider ul').css("transition", "none");
      this.EV('drag', 'timeline', this.currentYear.year)
    },
    onTimelinePanMove: function(ev) {
      var newOffset = this.slideParams.offset + ev.deltaX ;
      $('.timeline__slider ul').css({transform: "translateX(" + newOffset  + 'px)'});
      this.swipeDistance += Math.abs(ev.velocityX)
      if (this.swipeDistance > this.swipeClickiness) {
        audioload(this.audio.swipe).then(audioplay)
        this.swipeDistance = 0
      }
      console.log(this.swipeDistance);
    },
    onTimelinePanEnd: function(ev) {

      var offset = $(window).width() / 2;

      var distances = $.makeArray($('.timeline__slider ul li')
                       .map((i, val) => [[ $(val).offset().left - offset, val ]] ))

      var closest = distances.filter( function ( e ) {
        return ev.additionalEvent == "panleft" ? e[0] < 0 : e[0] > 0
      })
      $(ev.additionalEvent == "panleft" ? closest[closest.length - 1][1].click() : closest[0][1]).click();

      $('.timeline__slider ul').css("transition", "transform 0.5s ease");
    }
	},
  watch: {
    currentYearIndex: function() {
      $('#timeline ul').css({ transform: 'translateX(' + (( this.currentYear.year-this.minYear )/( this.maxYear-this.minYear )) * -100 + '%)'});
      $('#timeline li').removeClass('active').eq(this.currentYearIndex).addClass('active');
    },
    top5: function() {
      var vm = this;
      var countriesToShow;
      if (vm.currentYearIndex != 0) {
        countriesToShow = $.map(vm.top5, function(country) {
          return country;
        })
      } else {
        countriesToShow = [];
      };
      var maxvalue = Math.max(...countriesToShow.map(c => parseInt(c.value)));
      countriesToShow.push({name: 'UK'});
      var pins = $('.globe ul li');
      var showpins = pins.filter(function(i) {
        var countryNames = countriesToShow.map(c => c.name);
        return countryNames.indexOf($(this).find('span').text()) + 1; // +1 to make zeroth array element truthy for filtering
      })
      showpins.each(function(i, e) {
        var name = $(this).find('span').text();
        if (name != "UK") {
          var country = countriesToShow.filter(c => c.name == name)[0];
          var height = (((7 * country.value)/maxvalue) + 3) + "rem"; // 7 + 3 makes max 10rem
          $(e).css("height",height);
        }
      });
      pins.css("opacity", 0);
      showpins.css("opacity", 1);
    },
    timer: function(){
      var vm = this;
      if (vm.timer > vm.timeout) {
        vm.mode = vm.DISPLAYMODE.ATTRACT;
        vm.showhelp = false;
        vm.currentYearIndex = 0
        vm.resetTimer();
        vm.$ga.event('migration_dashboard', 'session_end', vm.sessionTimer)
        vm.sessionTimer = 0;
      }
    }
  }
});







// WEBPACK FOOTER //
// ./src/main.js